/***************************************************************************************************
** SessionContext
***************************************************************************************************/

import { use, createContext, useState, useEffect } from "react";

export const SessionContext = createContext();

export const SessionContextProvider = (props) => {
  const setCurrentPage = (pageKey) => {
    setSession((currentSession) => ({ ...currentSession, currentPageKey: pageKey }));
  };

  const initialSession = {
    currentPageKey: undefined,
    setCurrentPage: setCurrentPage,

    // KEEP FOR INTERPOLATION until we can add to interpolationData
    currentUserId: window.appContext.currentUserId,
    currentUserIpAddress: window.appContext.currentUserIpAddress,
    currentUserAgent: window.appContext.currentUserAgent,
    isCurrentUserAdmin: window.appContext.isCurrentUserAdmin,
  };

  const [session, setSession] = useState(initialSession);

  useEffect(() => {
    setSession((previousSession) => ({
      ...previousSession,
      isCurrentPage: (pageKey) => Boolean(pageKey && pageKey === previousSession.currentPageKey),
    }));
  }, [session.currentPageKey]);

  return (
    <SessionContext value={session}>
      {props.children}
    </SessionContext>
  );
};

// TODO: Rebuild session object (e.g., add missing ids/objects)

export const useSessionContext = () => {
  const context = use(SessionContext);

  if (!context) {
    throw new Error("SessionContext must be used within a SessionContextProvider");
  }

  return context;
};
